import { render } from "./CallCenterGeography.vue?vue&type=template&id=3cebe405&ts=true"
import script from "./CallCenterGeography.vue?vue&type=script&lang=ts"
export * from "./CallCenterGeography.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__